import axioslib, { AxiosInstance, AxiosRequestConfig } from "axios";
import { AuthInterceptor } from "./AuthInterceptor";
import VersionInterceptor from "@/api/VersionInterceptor";
import { Logger } from "@iloq/shared";
import { IBulletin } from "@iloq/shared";

export default class BulletinApi {
  private readonly axios: AxiosInstance;

  constructor() {
    this.axios = axioslib.create();
    AuthInterceptor.setAuthInterceptors(this.axios);
    VersionInterceptor.setVersionInterceptor(this.axios);
  }

  fetchBulletin(countryCode: string) {
    const options: AxiosRequestConfig = {
      method: "GET",
      url: `/api/v1/news/bulletin/${countryCode}`,
    };
    return this.axios(options)
      .catch((error) => {
        Logger.error("BulletinApi.fetchBulletin failed:", error);
        return Promise.reject(error);
      })
      .then((result) => {
        Logger.debug("BulletinApi.fetchBulletin result:", result);
        const bulletinResult = result.data as IBulletin[];

        return bulletinResult.map((item) => ({
          id: item.id,
          date: item.date,
          title: item.title,
          slug: item.slug,
          bulletin_category: item.bulletin_category,
          bulletin_category_ids: item.bulletin_category_ids,
          bulletin_category_slug: "",
          content: item.content,
          featured_image_url: `https://iloq.com${item.featured_image_url}`,
        }));
      });
  }
}
